import Select from "./components/Select";
import useFieldState from "./hooks/useFieldState";
import useForm from "./hooks/useForm";

const Year = () => {
  const { register } = useForm();
  const [fieldDataState] = useFieldState();
  const { year } = fieldDataState;

  return (
    <Select
      options={year}
      label="Year"
      name="year"
      ref={register}
      defaultValue={year[0].id}
    />
  );
};

export default Year;
